import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { AlertType } from './alert.model';

@Component({
    selector: 're-alert',
    templateUrl: './alert.component.html',
    styleUrl: './alert.component.scss',
    standalone: false
})
export class AlertComponent {


  private _type: AlertType = AlertType.INFO;

  @Input()
  public get type(): AlertType {
    return this._type;
  }
  public set type(value: AlertType) {
    value = <AlertType>value.toLowerCase();
    this._type = value;
    if (value == AlertType.INFO)
      this.alertClass = " alert-info";
    if (value == AlertType.DANGER)
      this.alertClass = " alert-danger";
    if (value == AlertType.WARNING)
      this.alertClass = " alert-warning";
    if (value == AlertType.DARK)
      this.alertClass = " alert-dark";
    if (value == AlertType.LIGHT)
      this.alertClass = " alert-light";
    if (value == AlertType.PRIMARY)
      this.alertClass = " alert-primary";
    if (value == AlertType.SECONDARY)
      this.alertClass = " alert-secondary";
    if (value == AlertType.SUCCESS)
      this.alertClass = " alert-success";

    this.generateClasses();
  }
  alertClass = "";


  generateClasses() {
    this.classes = `${this.alertClass} ${this.dismissible ? 'alert-dismissible' : ''} ${this.class}`;
  }

  private _class;
  @Input("class")
  public get class() {
    return this._class;
  }
  public set class(value) {
    this._class = value;
    this.generateClasses();
  }

  private _dismissible = true;
  @Input()
  public get dismissible() {
    return this._dismissible;
  }
  public set dismissible(value) {
    this._dismissible = value;
    this.generateClasses();
  }



  classes = "";



  @Output()
  close = new EventEmitter();


  closeAlert() {
    this.close.emit(null);
  }
}
